module.exports = __webpack_public_path__ + "img/img4116.2a566157.jpg";